<template>
  <div>
    <NuxtLayout>
      <template #body_page>
        <div id="page-gallery">
          <GalleryBanner
            :pageLevel = "galleryInfor?.settings && galleryInfor?.settings.page_level"
            :breadcrumbs="breadcrumb"
            :checkGlobalGallery="checkGlobalGallery"
            :readmore="travelGuideData.galleryDescription"
          />
          <div class="container" id="container" ref="container">
            <div
              class="flex flex-wrap items-start wp-100 relative"
              :class="[$device.isDesktop ? 'justify-between' : 'justify-center']"
            >
              <!--          <div class='wp-22">-->
              <div
                class="fixed z-998 top-0 left-0 right-0 bottom-0 loading-mask"
                v-if="loading"
              >
                <span class="loader" role="status" aria-label="Loading"></span>
              </div>
              <div class="filter" v-if="$device.isDesktop">
                  <FilterLeft
                    :fullPathChange="fullPathChange"
                    v-model:loaded="loaded"
                    :mapCurrency="mapCurrency"
                  />
              </div>
              <div class="trip-list" v-if="loaded">
                <div
                  class="tl-db flex flex-wrap wp-100 justify-between tl-mb items-center tl-pl-0 tl-justify-start"
                >
                  <h3
                    v-if="titleTrips"
                    class="fw-900 fs-22 lh-22 black mt-0 mb-10 tl-mb-20 tl-wp-100"
                  >
                    {{ titleTrips }}
                    <!--                  {{ getTitleTrips }}-->
                  </h3>

                  <div class="flex">
                    <button
                      class="button button-primary mb-10 mr-20"
                      v-if="$device.isMobileOrTablet"
                      @click="openFilter"
                    >
                      <svg
                        aria-hidden="true"
                        class="mr-12"
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.60554 1.75H11.4033L6.9956 7.2625L2.60554 1.75ZM0.186163 1.40875C1.9633 3.675 5.24485 7.875 5.24485 7.875V13.125C5.24485 13.6062 5.64075 14 6.12463 14H7.88417C8.36805 14 8.76394 13.6062 8.76394 13.125V7.875C8.76394 7.875 12.0367 3.675 13.8138 1.40875C14.2625 0.83125 13.849 0 13.1188 0H0.881183C0.150972 0 -0.262521 0.83125 0.186163 1.40875Z"
                          fill="white"
                        />
                      </svg>
                      Filters
                    </button>
                    <SortSelection v-if="cardDataList.total" />
                  </div>
                </div>
                <template v-if="cardDataList.total > 0">
                  <div
                    class="trip-list-card grid items-center mb-justify-center">
                    <div
                      class="trip-card mb-pl-0"
                      v-for="item in cardDataList.items"
                      :key="item.url"
                    >
                      <TripCard :cardData="item" />
                    </div>
                  </div>
                  <div class="pt-30">
                  <client-only>
                    <Pagination
                      v-if="totalPage > 1"
                      :textRecord="'Tours'"
                      :totalRecord="cardDataList.total"
                      :totalPage="cardDataList.last_page"
                      :perPage="cardDataList.per_page"
                      :from="cardDataList.from"
                      :to="cardDataList.to"
                      v-model:currentPage="currentPage"
                    />
                  </client-only>
                  </div>
                </template>
                <template v-if='!fromLinkNotFound && !cardDataList.total && !showBannerCountryHasCoverage'>
                  <div class="tc fs-14 ma-0-auto mt-40" style="max-width: 350px">
                    <div class="mb-20 lh-18">
                      <div class="fw-600 lh-16 fs-16 mb-20">
                        There are no results for your search criteria
                      </div>
                      Try updating your filters to get more <br />results or
                      <router-link :to="goToSubmitEnquiry()" class="submit-enquiry-link"
                        >submit an enquiry</router-link
                      >
                      for a tailor-made trip <br />that matches your requirements.
                    </div>
                    <div class="mb-mb-50">
                      <button
                        class="button button-outline"
                        @click="clearAllFilter()"
                      >
                        Clear All Filters
                      </button>
                    </div>
                  </div>
                </template>
                <template v-else-if='showBannerCountryHasCoverage'>
                  <DesignTrip
                    :pageLevel = "galleryInfor?.settings && galleryInfor?.settings.page_level"
                    :pageTypeName="pageTypeNameDesignTrip"
                    :pageTypeSetting="
                      galleryInfor?.settings && galleryInfor?.settings.page_type
                    "
                    :checkGlobalGallery="checkGlobalGallery"
                    :urlDesignEnquiry="urlDesignEnquiry"
                    :isCountryNoTripHasLDCoverage="!!cardDataList.has_ld_coverage"
                  />
                </template>
              </div>
            </div>
            <template v-if="loaded && !showBannerCountryHasCoverage">
              <DesignTrip
                :pageLevel = "galleryInfor?.settings && galleryInfor?.settings.page_level"
                :pageTypeName="pageTypeNameDesignTrip"
                :pageTypeSetting="
                  galleryInfor?.settings && galleryInfor?.settings.page_type
                "
                :checkGlobalGallery="checkGlobalGallery"
                :urlDesignEnquiry="urlDesignEnquiry"
              />
              <SectionBenefits></SectionBenefits>
              <div
                class="flex justify-between pt-45 mb-db"
                v-if="isCountryGallery || (isRegionGallery && travelGuideData.guideDescription)"
              >
                <DiscoverExperts
                  v-if="isCountryGallery"
                  :class="['mb-wp-100', (isCountryGallery && travelGuideData.guideDescription) ? 'mr-40 wp-45' : 'wp-100']"
                  :country-name="countryName"
                  :countryURL="countryURL"
                />
                <TravelGuide
                  v-if="travelGuideData.guideDescription"
                  :class="['mb-wp-100', (isCountryGallery && travelGuideData.guideDescription) ? 'wp-55' : 'wp-100']"
                  :title="travelGuideData.title"
                  :description="travelGuideData.guideDescription"
                  :quickLinks="travelGuideData.quickLinks"
                  :url="travelGuideData.url"
                  :urlTitle="category"
                  :countryName = "countryName"
                />
              </div>
              <client-only>
                <div class='pt-80' v-if='isCountryGallery && showBlogSection'>
                  <SectionBlog
                    :category="countryURL"
                    :countryName = "countryName"
                    @hiddenBlog="hiddenBlogSection"
                    ref="blog"
                  />
                </div>
                <QuickLink v-if="Object.keys(quickLinksData).length" />
              </client-only>
            </template>
          </div>
        </div>
      </template>
    </NuxtLayout>
    <AppModal :show="showModal" :isFilter="true" @closeModal="handleCloseModal" v-if="$device.isMobileOrTablet">
      <template #header>
        <div>
          <div class="dib black fs-16 lh-16 fw-700 mr-15">Filter Results</div>
          <div
            v-if="clearFilterStatus"
            class="dib red fs-11 lh-13 fw-700 hand"
            @click="clearAllFilter()"
          >
            Clear Filters
          </div>
        </div>
      </template>
      <template #body>
          <FilterLeft
          :fullPathChange="fullPathChange"
          v-model:loaded="loaded"
          :mapCurrency="mapCurrency"
          >
          </FilterLeft>
      </template>
      <template #footer>
        <div class="flex justify-between items-center">
          <div>
            <span
              v-if="clearFilterStatus"
              class="red fs-14 lh-17 fw-700 hand"
              @click="clearAllFilter()"
              >Clear Filters</span
            >
          </div>
          <div>
            <button class="button button-primary" @click="searchTripMB()">
              Search Trips
            </button>
          </div>
        </div>
      </template>
    </AppModal>
    <client-only>
      <Teleport to="head">
        <component :is="'script'" type="application/ld+json">
          {{ JSON.stringify(jsonLdContent) }}
        </component>
      </Teleport>
    </client-only>

    <PopupCommon
      :modalTitle="modalNotFoundTitle"
      :modalActive="modalNotFoundActive"
      @update:close="closeNotFoundModal()"
      maxWidth="430"
    >
      <template #content>
        <TripNotFound/>
      </template>
    </PopupCommon>
  </div>
  </template>

<script setup>
  // import DefaultLayout from '~/components/globals/layout/DefaultLayout'
  import { computed, nextTick, onMounted, provide, reactive, ref, watch } from 'vue'
  import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
  import TripCard from '~/components/elements/TripCard/TripCard'
  import DesignTrip from '~/components/pages/Gallery/sections/DesignTrip'
  import DiscoverExperts from '~/components/pages/Gallery/sections/DiscoverExperts'
  import FilterLeft from '~/components/pages/Gallery/sections/FilterLeft'
  import GalleryBanner from '~/components/pages/Gallery/sections/GalleryBanner'
  import QuickLink from '~/components/pages/Gallery/sections/QuickLink'
  import SortSelection from '~/components/pages/Gallery/sections/SortSelection'
  import TravelGuide from '~/components/pages/Gallery/sections/TravelGuide'
  import SectionBlog from '~/components/sections/SectionBlog/SectionBlog'
  import SectionBenefits from '~/components/sections/SectionGlobalHome/SectionBenefits/SectionBenefits'
  import Pagination from '~/components/sections/SectionPagination/Pagination'
  import destinationsApi from '~/composables/api/destinationsApi'
  import filtersApi from '~/composables/api/filtersApi'
  import galleryApi from '~/composables/api/galleryApi'
  // import { useHead } from '@vueuse/head'
  import TripNotFound from "~/components/pages/TripPlanDetail/sections/SectionPopup/TripNotFound.vue"
  import AppModal from '~/components/ui/modal/AppModal'
  import PopupCommon from "~/components/ui/popup/PopupCommon.vue"
  import { TRIP_NOT_FOUND, DEFINE_META_TAG } from '~/constant/common'
  import { STATIC_CURRENCIES } from '~/enum/currency.enum'
  import { formatHTML, isEmpty, pluralize } from '~/helper'
  // import { getCookie } from '~/mixins/cookie'
  import { useGetCookie } from '~/composables/common/useCustomCookie'
  import { debounceHeapTracking } from '~/mixins/heap'
  import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
  import { useCurrenciesStore } from '~/store/pinia/currencies'
  import { useGalleryStore } from '~/store/pinia/gallery'
  import { useTripPlanStore } from '~/store/pinia/tripPlan'
  import { useGeneralInfoStore } from '~/store/pinia/generalInfo'
  import { useHeapStore } from '~/store/pinia/heap'
  
    const route = useRoute()
    const countryName = ref('')
    const router = useRouter()
    const { isMobileOrTablet, isDesktop } = useDevice()
    const loadingBot = ref()
    const modalNotFoundTitle = ref('')
    const modalNotFoundActive = ref(false)
    const fromLinkNotFound = ref(false)
    const currenciesStore = useCurrenciesStore()
    const galleryStore = useGalleryStore()
    const tripPlanStore = useTripPlanStore()
    const generalStore = useGeneralInfoStore()
  
    const selectedCurrency = computed(() => {
      // return store.getters['currenciesStore/getCurrencySelected']
      return currenciesStore.getCurrencySelected
    })

    const mapCurrency = ref(selectedCurrency.value)

    const container = ref()

    const showModal = ref(false)

    const currentPage = ref(1)
    const perPage = computed(() => isMobileOrTablet ? 14 : 15 );
    const totalData = ref(0)
    const totalPage = ref(0)
    const blog = ref(null)
    const galleryPageData = ref(null)
    const heapStore = useHeapStore()

    const cardDataList = computed(() => galleryStore.tripData)
    const popularList = computed(() => galleryStore.popularList)
    const galleryHeap = computed(()=> heapStore.getGalleryHeap)
    const queryChange = computed(() => route.query)
    const {
      public: { publicDomain },
    } = useRuntimeConfig()
    const loading = ref(false)
    const loaded = ref(false)
    
    const travelGuideData = reactive({
      title: '',
      galleryDescription: '',
      guideDescription: '',
      quickLinks: [],
      url: '',
    })

    const priceInit = computed(() => {
      return '0-'
    })

    const hasQueryParams = computed(() => {
      return queryChange.value.duration || queryChange.value.activity || queryChange.value.price
    })

    const showBannerCountryHasCoverage = computed(() => {
      return cardDataList.value?.has_ld_coverage === 1 && cardDataList.value?.total === 0 && !hasQueryParams.value
    })

    const isCountryGallery = computed(() => {
      return galleryInfor.value?.settings && galleryInfor.value?.settings.page_type === 'country'
    })

  const isThemeGallery = computed(() => {
    return galleryInfor.value?.settings && galleryInfor.value?.settings.page_type === 'theme'
  })

    const isRegionGallery = computed(() => {
      return galleryInfor.value?.settings && galleryInfor.value?.settings.page_type === 'destination'
    })

    const titleTrips = ref('')

    const isAllowTestPage = () => {
      const dj_tmod = useGetCookie('dj_tmod')
      const testPages = ['afghanistan', 'somalia'];
      // if (getCookie('dj_tmod') == 'on' && route.params.types && testPages.includes(route.params.types)) {
      if (dj_tmod.value == 'on' && route.params.types_ && testPages.includes(route.params.types_)) {
        return true
      }

      return false
    }

    const getDataTrips = async (tripParams) => {
      if(route.query.currency && route.query.price){
        const currency = STATIC_CURRENCIES.find(currency => currency.code === route.query.currency)
        if(!isEmpty(currency)){
          tripParams['currency'] = currency.code
        }
      }

      try {
        const res = (await galleryApi.getTripList('trips', tripParams)).data.value
        if(!res) {
           throw createError({
                statusCode: 404,
                fatal: true,
                statusMessage: "Page not found",
                data: null
              })
          return;
        }

        totalData.value = res.data.items.length
        //console.log('----', totalData.value, route.name, isEmpty(route.query))
        if (totalData.value === 0 && route.name === 'types-gallery' && isEmpty(route.query) /*&& !isAllowTestPage()*/) {
          fromLinkNotFound.value = true
        } else {
          fromLinkNotFound.value = false
        }

        totalPage.value = Math.ceil(res.data.total / perPage.value)

        galleryStore.setTripData(res.data)
        titleTrips.value = getTitleTrips(res.data)
      } catch (e) {
        console.log({'Get trip list error': e})
        throw new Error('Get trip list error : ', { cause: e })
      }
    }

    const getTravelGuide = async (params) => {
      try {
        const { data: resp } = (await destinationsApi.getTravelGuide(params)).data.value

        travelGuideData.title = resp.title
        if (resp && resp.items && resp.items.length) {
          if(resp.items[0].type === 'gallery') {
            travelGuideData.galleryDescription = resp.items[0].content
            if(resp.items[1] && resp.items[1].content) {
              travelGuideData.guideDescription = resp.items[1].content
              travelGuideData.quickLinks = resp.items.slice(1, 4)
            }
          }
          else {
            travelGuideData.galleryDescription = ''
            travelGuideData.guideDescription = resp.items[0].content
            travelGuideData.quickLinks = resp.items.slice(0, 3)
          }

          travelGuideData.url = '/' + resp.url
          galleryStore.setDestinations(resp)
        }
      } catch (e) {
        console.log(e)
        throw new Error('Get gallery travel guide error : ', { cause: e })
      }
    }

    const getFilterOptions = async (params) => {
      try {
        const resp = (await filtersApi.getFilters(params)).data.value
        const data = Object.assign({}, resp?.data)

        if (data.durations && data.durations.length) {
          const lastIndex = data.durations.length - 1
          const lastRange = data.durations[lastIndex].range
          data.durations[lastIndex].range = lastRange.replace(/\+/g, '-')
        }

        galleryStore.setFiltersList(data)
      } catch (e) {
        console.log(e)
        throw new Error('Get gallery filter option error : ', { cause: e })
      }
    }

    const category = computed(() => {
      var pathParam = route.path
      var cate = pathParam.substring(0, pathParam.lastIndexOf('-'))
      return cate.replace(/[^a-zA-Z ]/g, '')
    })

    const countryURL = computed(() => {
      const pathParam = route.path
      const cate = pathParam.substring(1, pathParam.lastIndexOf('-'))
      return cate
    })

    const showBlogSection = ref(true)
    const heapTrack = async (refining = true) => {
      await nextTick();
      debounceHeapTracking('View Gallery', {
        type: route?.name === 'trip-gallery' ? 'all-trips' : 'types-tours',
        source_widget: galleryHeap.value?.source_widget || '',
        number_of_trip_plan: cardDataList.value?.total,
        filter: Object.keys(route?.query).join(', '),
        destination_filter: route?.query?.destination,
        price_filter: route?.query?.price,
        duration_filter: route?.query?.duration?.replace(",", ", "),
        activity_filter: route?.query?.activity?.replace(",", ", "),
        local_designer_filter: route?.query?.designer,
        has_travel_guide: !!travelGuideData.guideDescription,
        number_of_blog_posts: blog.value?.listBlogPost?.length || 0,
        sort: route?.query?.sort || 'popular',
        is_refining_filter_sort: refining,
        page: cardDataList.value?.total ? route?.query?.page || 1 : 0,
      })
      debounceAmplitudeScriptTracking((route.name === 'trip-gallery' ? 'View Global Gallery' : '')  || (isCountryGallery.value ? 'View Country Gallery' : 'View Theme Gallery'), {
        type: route?.name === 'trip-gallery' ? 'all-trips' : 'types-tours',
        source_widget: galleryHeap.value?.source_widget || '',
        number_of_trip_plan: cardDataList.value?.total,
        filter: Object.keys(route?.query).join(', '),
        destination_filter: route?.query?.destination,
        price_filter: route?.query?.price,
        duration_filter: route?.query?.duration?.replace(",", ", "),
        activity_filter: route?.query?.activity?.replace(",", ", "),
        local_designer_filter: route?.query?.designer,
        has_travel_guide: !!travelGuideData.guideDescription,
        number_of_blog_posts: blog.value?.listBlogPost?.length || 0,
        sort: route?.query?.sort || 'popular',
        is_refining_filter_sort: refining,
        page: cardDataList.value?.total ? route?.query?.page || 1 : 0,
      })
    }
    const hiddenBlogSection = async (length) => {
      showBlogSection.value = length >= 1
    }

    const galleryInfor = computed(() => galleryStore.galleryInfor)

    const getPopularDestParams = (paramSetting) => {
      if (
        route.name === 'trip-gallery' ||
        route.name === 'free-cancellation-trips' ||
        (galleryInfor.value &&
          galleryInfor.value?.settings &&
          galleryInfor.value?.settings.page_type === 'theme') ||
        (galleryInfor.value &&
          galleryInfor.value?.settings &&
          galleryInfor.value?.settings.page_type === 'activity' &&
          galleryInfor.value?.settings.page_level === 0)
      )
        popularDestParams.level = 0
      else if (
        (galleryInfor.value &&
        galleryInfor.value?.settings &&
        galleryInfor.value?.settings.page_type === 'country') ||
        (galleryInfor.value?.settings &&
          galleryInfor.value?.settings.page_type === 'activity' &&
          galleryInfor.value?.settings.page_level === 1) ||
        (galleryInfor.value?.settings &&
          galleryInfor.value?.settings.page_type === 'duration' &&
          galleryInfor.value?.settings.page_level === 1)
      )
        popularDestParams.level = 1
      else popularDestParams.level = 2

      const hasParamSetting = Object.keys(paramSetting).length

      popularDestParams.country_code =
        (hasParamSetting && paramSetting.country_ids.join()) || undefined
      popularDestParams.activity =
        (hasParamSetting && paramSetting.activity.join()) || undefined
      popularDestParams.duration =
        (hasParamSetting && paramSetting.duration) || undefined
      popularDestParams.theme_id =
        hasParamSetting && paramSetting.theme_id > 0
          ? paramSetting.theme_id
          : undefined
      popularDestParams.deal_id =
        hasParamSetting && paramSetting.deal_id > 0
          ? paramSetting.deal_id
          : undefined
      popularDestParams.destination_id =
        (hasParamSetting && paramSetting.dest_ids.join()) || undefined
      popularDestParams.is_free_cancellation =
        (hasParamSetting && paramSetting.is_free_cancellation) || false
    }

    const getTripParams = (urlParams, paramSetting) => {
      let hasParamSetting = 0
      if (paramSetting !== null || paramSetting !== 'undefined')
        hasParamSetting = Object.keys(paramSetting).length

      tripParams.page = urlParams.page || currentPage.value
      tripParams.sort = urlParams.sort || 'popular'
      tripParams.destination =
        urlParams.destination ||
        (hasParamSetting && paramSetting.destination.join()) ||
        undefined
      tripParams.duration =
        urlParams.duration ||
        (hasParamSetting && paramSetting.duration) ||
        undefined
      tripParams.activity =
        urlParams.activity ||
        (hasParamSetting && paramSetting.activity.join()) ||
        undefined
      tripParams.price = urlParams.price || priceInit.value
      tripParams.designer = urlParams.designer || undefined
      tripParams.is_free_cancellation =
        urlParams.free_cancellation ||
        (hasParamSetting && paramSetting.is_free_cancellation) ||
        false
      tripParams.deal_id =
        paramSetting.deal_id > 0
          ? hasParamSetting && paramSetting.deal_id
          : undefined
      tripParams.theme_id =
        paramSetting.theme_id > 0
          ? hasParamSetting && paramSetting.theme_id
          : undefined
    }

    const getDataGalleryPage = async () => {
      try {
        let resData = null
        if (process.server && process.PAGE_SETTINGS) {
          //let pageSettings = JSON.parse(process.PAGE_SETTINGS) || {}
          let pageSettingsList = process.PAGE_SETTINGS
          if (pageSettingsList.hasOwnProperty(route.path)) {
            resData = pageSettingsList[route.path]
            //console.log('-----------', resData)
          }
        }
        else if (process.client && window.page_settings && window.page_settings.hasOwnProperty(route.path)) {
          //let {data: resData1} = (await galleryApi.getGalleryPage(route.path)).data.value
          if(window.page_settings[route.path]) {
            resData = window.page_settings[route.path]
          }
        }

        if (!resData) {
          resData = (await galleryApi.getGalleryPage(route.path)).data.value?.data
        }
        else if (process.client) {
          if (!window.page_settings) {
            window.page_settings = {}
          }

          window.page_settings[route.path] = resData
        }

        //console.log('+++++++++++++aaaaaa-----', resData)
        if(!isEmpty(resData) && resData?.name)
          countryName.value = resData?.name.lastIndexOf(' Tours') !== -1 ? resData?.name.substring(0, resData?.name.lastIndexOf(' Tours')) : resData?.name
        galleryStore.setGalleryInfor(resData)
        return resData
        // loading.value = false
      } catch (e) {
        loading.value = false
        // loaded.value = true
        console.log(e.message)
        throw new Error('Get gallery data error : ', { cause: e })
      }
    }

    const checkGlobalGallery = computed(() => {
      if (route.path === '/trip-gallery') {
        return false
      }
      return true
    })

    const breadcrumb = computed(() => {
      let url = []
      if (route.name === 'types-gallery') {
        const breadcrumbInfor =
          galleryInfor.value && galleryInfor.value.breadcrumb
        url = breadcrumbInfor
      }
      if (route.name === 'free-cancellation-trips') {
        url = [
          {
            link: '/free-cancellation-trips',
            title: 'Free Cancellation Trips',
          },
        ]
      }
      if (route.name === 'trip-gallery') {
        url = [
          {
            link: '/trip-gallery',
            title: 'Designer Journeys Tours',
          },
        ]
      }
      return url
    })

    const urlDesignEnquiry = computed(() => {
      if (route.name === 'types-gallery') {
        const strCurr = route.path
        return strCurr.replace('-tours', '')
      } else if (route.name === 'trip-gallery') {
        const total = cardDataList.value?.total
        const has_ld_coverage = cardDataList.value?.has_ld_coverage
        if (total === 0 && has_ld_coverage === 1 && route?.query?.destination) {
          return `/${route?.query?.destination}` 
        } 
        return ''
      }
    })

    const pageTypeNameDesignTrip = computed(() => {
      if(galleryInfor.value && galleryInfor.value?.settings) {
        if(galleryInfor.value?.settings.page_level === 0) {
          return galleryInfor.value.name
        } else {
          return galleryInfor.value?.settings.country_name || galleryInfor.value?.settings.region_name
        }
      }
      if(route?.query?.destination) {
        const total = cardDataList.value?.total
        const has_ld_coverage = cardDataList.value?.has_ld_coverage
        const destination = popularList.value.find((item) => item.url === route?.query?.destination)
        return total === 0 && has_ld_coverage === 1 ? destination?.name : ''
      }
      return ''
    })

    const titlePage = computed(() => {
      switch (route.name) {
        case 'trip-gallery':
          return 'Design Your Trip with a Local Designer | Designer Journeys'
        case 'free-cancellation-trips':
          return 'Discover Our Free Cancellation Trips | Designer Journeys'
        default:
          // return galleryInfor.value ? (galleryInfor.value?.meta_title || '').replace(' Trip | Designer Journeys', ' Tour | Designer Journeys') : ""
          return galleryInfor.value?.meta_title
      }
    })

    const descriptionPage = computed(() => {
      switch (route.name) {
        case 'trip-gallery':
          return 'Explore the best tours all over the world with Designer Journeys. Connect with our Local Designers and create your next extraordinary travel experience!'
        case 'free-cancellation-trips':
          return 'With Free Cancellation, you can plan, book and travel the world with confidence. T&Cs apply.'
        default:
          return galleryInfor.value ? galleryInfor.value?.meta_description : ""
      }
    })

    useHead({
      link: computed(() => {
        let prevPage = 0
        let nextPage = 0
        const link = `${publicDomain}${route.path}`

        if (parseInt(route?.query?.page) === 1 || route?.query?.page === undefined) {
          prevPage = undefined
          nextPage = (totalPage.value > 1) ? 2 : undefined
        } else {
          prevPage = parseInt(route?.query?.page) - 1
          nextPage = (parseInt(route?.query?.page) < totalPage.value) ? (parseInt(route?.query?.page) + 1) : undefined
        }

        return [
          { rel: 'canonical', href: `${link}`, hreflang: 'en' },
          prevPage ? { rel: "prev", href: `${link}?page=${prevPage}`} : {},
          nextPage ? { rel: "next", href: `${link}?page=${nextPage}`} : {}
        ]}),
      title: computed(() => titlePage.value),
      meta: [
      ...DEFINE_META_TAG,
        {
          name: 'robots',
          content: useAppConfig().disableBotsIndexing == 1 ? 'NOINDEX, NOFOLLOW' : 'INDEX, FOLLOW'
        },
        {
          name: `title`,
          content: computed(()=> titlePage.value),
        },
        {
          name: `description`,
          content: computed(()=> descriptionPage.value),
        },
      ],
    })
    useSeoMeta({
      ogTitle:  computed(()=> titlePage.value),
      ogDescription:  computed(()=> descriptionPage.value),
      ogType: 'website',
      ogUrl: `${publicDomain}${route.fullPath}`,
      ogSiteName: 'Designer Journeys',
      ogImage: computed(()=>galleryInfor.value?.meta_image),
      fbAppId: '452745475618385',
      href: `${publicDomain}${route.fullPath}`,
      twitterTitle:  computed(()=> titlePage.value),
      twitterDescription:  computed(()=> descriptionPage.value),
      twitterImageAlt: computed(()=> titlePage.value),
      twitterCard: 'summary',
      twitterImage: computed(()=>galleryInfor.value?.meta_image),
    })

    const getPopularDestination = async (paramSetting) => {
      try {
        await galleryStore.popularDestination(paramSetting)
      } catch (e) {
        console.log(e.message)
        throw new Error('Get gallery popular destination error : ', { cause: e })
      }
    }

    const resetCurrentPage = () => {
      const index = route.query.page
      currentPage.value = index ? parseInt(index) : 1
    }

    provide('pageLoaded', loaded)

    watch(selectedCurrency, (val) => {
      mapCurrency.value = val
    })

    let tripParams = reactive({
      limit: perPage.value,
      currency: selectedCurrency.value?.code,
    })

    let filterParams = reactive({
      full: 1,
      currency: selectedCurrency.value?.code,
    })

    let popularDestParams = reactive({
      limit: 15,
    })

    let fullPathChange = ref(false)

    const pathChange = computed(() => route.path)

    const deleteFilters = () => {
      delete tripParams.page
      delete tripParams.sort
      delete tripParams.destination
      delete tripParams.duration
      delete tripParams.activity
      delete tripParams.price
      delete tripParams.designer
      delete tripParams.is_free_cancellation
      delete tripParams.deal_id
      delete tripParams.theme_id

      delete filterParams.destination
      delete filterParams.duration
      delete filterParams.activity
      delete filterParams.deal_id
      delete filterParams.theme_id
    }

    watch(
      [pathChange, queryChange],
      async ([currentPath, currentQuery], [prePath, preQuery]) => {
        // console.log('Gallery watch', route)
        if (route.name === 'trip-gallery' || route.name === 'types-gallery') {
          showBlogSection.value = true
          loading.value = true
          // Reset show blog status
          // isCountryGallery.value = false
          if (currentPath !== prePath) {
            return
            // resetCurrentPage()
            // currentURL()
            // deleteFilters()
            // fullPathChange.value = true
            // await getGalleryPage()
            // await heapTrack(false);
          } else {
            let urlQuery = currentQuery
            fullPathChange.value = false

            if (
              urlQuery.destination ||
              urlQuery.duration ||
              urlQuery.activity ||
              urlQuery.price ||
              urlQuery.designer ||
              urlQuery.free_cancellation
            )
              clearFilterStatus.value = true
            else clearFilterStatus.value = false

            if (urlQuery.page === preQuery.page) {
              currentPage.value = 1
            }

            let paramSettings =
              galleryInfor.value && galleryInfor.value.filter_options
                ? galleryInfor.value.filter_options
                : {}

            getTripParams(urlQuery, paramSettings)

            tripParams.currency = selectedCurrency.value.code

            if (showModal.value === false) {
              await getDataTrips(tripParams)
            }
          }

          currenciesStore.setCurrencyDropdownClick(0)

          loading.value = false
          loaded.value = true
        }
      },
    )

    function openFilter() {
      showModal.value = true
    }

    const handleCloseModal = (val) => {
      showModal.value = val
    }

    const getTitleTrips = (data) => {
      // let name = ''
      if (route.name === 'free-cancellation-trips') {
        return `${data.total} Free Cancellation ${pluralize({
          count: data.total,
          noun: 'Trip',
          full: false,
        })}`
      }
      if (route.name === 'trip-gallery') {
        if (showBannerCountryHasCoverage.value) {
          return ``
        }
        return `${data.total} Designer Journeys ${pluralize({
          count: data.total,
          noun: 'Tour',
          full: false,
        })}`
      }
      if (
        route.name === 'types-gallery' &&
        galleryInfor.value &&
        galleryInfor.value.name

      ) {
        if(galleryInfor.value?.settings &&
          galleryInfor.value?.settings.page_level === 0) {
          if(galleryInfor.value?.settings.page_type === "theme" || galleryInfor.value?.settings.page_type === "activity") {
            if(data.total <= 1) {
              return `${data.total} ${galleryInfor.value.name} Tour`
            } else {
              return `${data.total} ${galleryInfor.value.name} Tours`
            }
          } else {
            if (showBannerCountryHasCoverage.value) {
              return ``
            } else if(data.total <= 1) {
              return `${data.total} Tour in ${galleryInfor.value.name}`
            } else {
              return `${data.total} Tours in ${galleryInfor.value.name}`
            }
          }
        } else {
          if(data.total === 1) {
            return `${data.total} ${ galleryInfor.value?.settings.duration_name || galleryInfor.value?.settings.activity_name || '' } Tour in  ${galleryInfor.value?.settings.region_name|| galleryInfor.value?.settings.country_name}`
          } else {
            return `${data.total} ${ galleryInfor.value?.settings.duration_name || galleryInfor.value?.settings.activity_name || '' } Tours in  ${galleryInfor.value?.settings.region_name|| galleryInfor.value?.settings.country_name}`
          }
        }

      }

      // return name
    }

    async function searchTripMB() {
      try {
        loading.value = true;
        handleCloseModal(false)

        const urlQuery = route.query
        if (urlQuery.destination) {
          tripParams.destination = urlQuery.destination
        } else {
          delete urlQuery.destination
        }

        if (urlQuery.duration) {
          tripParams.duration = urlQuery.duration
        } else {
          delete tripParams.duration
        }

        if (urlQuery.activity) {
          tripParams.activity = urlQuery.activity || undefined
        } else {
          delete tripParams.activity
        }

        if (urlQuery.price) {
          let price = route.query.price.split('-')
          if (+price[0] < +price[1]) {
            tripParams.price = urlQuery.price
          } else {
            tripParams.price = priceInit.value
          }
        }

        if (urlQuery.designer) tripParams.designer = urlQuery.designer
        else delete tripParams.designer

        if (urlQuery.free_cancellation)
          tripParams.is_free_cancellation = urlQuery.free_cancellation || false

        await getDataTrips(tripParams)
      } catch (error) {
        console.log(error)
      } finally {
        loading.value = false
      }
    }

    const clearFilterStatus = ref(false)
    function clearAllFilter() {
      deleteFilters()
      galleryStore.setClearFilter(true)
      clearFilterStatus.value = false
    }

    const quickLinksData = ref({})

    const getQuickLinksData = async (pageSettings) => {
      if (pageSettings && pageSettings.settings) {
        if (
          pageSettings.settings.page_type === 'country' ||
          (pageSettings.settings.page_type === 'activity' &&
            pageSettings.settings.page_level === 1) ||
          (pageSettings.settings.page_type === 'activity' &&
            pageSettings.settings.page_level === 2) ||
          pageSettings.settings.page_type === 'duration' ||
          pageSettings.settings.page_type === 'destination'
        ) {
          try {
            const params = {
              country_id: pageSettings.filter_options.country_ids.join(),
              region_id:
                pageSettings.filter_options.region_id > 0
                  ? pageSettings.filter_options.region_id
                  : undefined,
            }
            const res = (await galleryApi.getQuickLinks(params)).data.value
            quickLinksData.value = res?.data
            galleryStore.setQuickLinks(res.data)
          } catch (e) {
            console.log(e.message)
          }
        }
        else {
          quickLinksData.value = {}
          galleryStore.setQuickLinks(null)
        }
      }
    }

    const goToSubmitEnquiry = () => {
      if (route.name === 'trip-gallery') {
        return { name: 'enquiry-submit-global' }
      }
      else if (route.name === 'types-gallery') {
          // const type = (process.server) ?  route.params?.types :  route.params?.types_
          return { name: 'enquiry-submit-destination', params: {galleryTypes: route.params?.types_} }
      }
      else {
        if (galleryInfor.value && galleryInfor.value.slug) {
          let slug = galleryInfor.value.slug
          return {
                name: 'enquiry-submit-destination',
                params: { galleryTypes: slug },
              }
        }
      }
    }

    const jsonLdContent = computed(() => {
      return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: galleryInfor?.value?.meta_title || galleryInfor.value?.name ? `${galleryInfor.value.name} Tours` : `Design Your Trip with a Local Designer | Designer Journeys`,
        description: galleryInfor?.value?.meta_desciption || formatHTML(travelGuideData.galleryDescription, 155),
        itemListElement: cardDataList.value?.items?.map((item, index) => {
          if (index < 5) return {
            '@type': 'ListItem',
            position: index+1,
            item: {
              '@type': 'Trip',
              name: item?.meta_title,
              description: item?.meta_description,
              url: `${useRuntimeConfig().public.publicDomain}/trip-gallery/${item.url}`,
              offers: {
                '@type': 'Offer',
                priceCurrency: 'AUD',
                price: item.price_in_aud.toFixed(2),
              },
              provider: {
                '@type': 'Person',
                name: item.designer.name,
              },
            },
          }
        }).filter(item => item),
      }
    })

    onBeforeRouteUpdate(() => {
      if(process.server) return
      const containerOffset = document.getElementById("container").offsetTop;
      setTimeout(() => {
        window.scrollTo({
          top: containerOffset - (isDesktop ? 130 : 0),
          behavior: "smooth"
        })
      }, 1);
    })

    onBeforeRouteLeave(async (to) => {
      if(isMobileOrTablet) {
        await nextTick()
      }
      if(["types-gallery", "trip-gallery"].includes(to.name)) {
        if(process.server) return
        const ele = document.getElementById("container")
        if(!ele) return
        const containerOffset = ele.offsetTop;
        window.scrollTo({
          top: containerOffset - (isDesktop ? to.name === "trip-gallery" ? 150 : 90 : 0),
          behavior: "smooth"
        })
      }
    })

    const dataTrip = computed(() => tripPlanStore.dataTrip)

    const closeNotFoundModal = (value) => {
      modalNotFoundActive.value = value;
    }

    const clearTravelGuideData = () => {
      travelGuideData.title = ''
      travelGuideData.galleryDescription = ''
      travelGuideData.guideDescription = ''
      travelGuideData.quickLinks = []
      travelGuideData.url = ''
    }

    const mapFilterParams = (paramSetting, pageType) => {
      filterParams.destination =
        paramSetting.destination.join() || undefined
      filterParams.duration = paramSetting.duration || undefined
      filterParams.activity = paramSetting.activity.join() || undefined
      filterParams.deal_id =
        paramSetting.deal_id > 0 ? paramSetting.deal_id : undefined
      filterParams.theme_id =
        paramSetting.theme_id > 0 ? paramSetting.theme_id : undefined
      filterParams.exclude_level = (pageType === 'country' || pageType === 'theme' || pageType === 'activity' ||
                                    route.name === 'free-cancellation-trips') ? 2 : undefined
    }

    const fetchDataOnMounted = () => {
      try {
        const arrRequest = [getFilterOptions(filterParams)]
        if (
          route.name === 'types-gallery' ||
          route.name === 'free-cancellation-trips'
        ) {
          arrRequest.push(getQuickLinksData(galleryPageData.value))
        }
        arrRequest.push(getPopularDestination(popularDestParams))
        Promise.all(arrRequest)
        loading.value = false
        loaded.value = true
      } catch (error) {
        console.log(`fetchDataOnMounted`, error)
        throw new Error('Fetch dataOnMounted error : ', { cause: error })
      }
    }
    onMounted(() => {
      // if (route.name === 'trip-gallery'){
      //   debounceAmplitudeScriptTracking("View Global Gallery")
      // }
      // if(isCountryGallery.value) {
      //   debounceAmplitudeScriptTracking("View Country Gallery")
      // }
      // if(isThemeGallery.value) {
      //   debounceAmplitudeScriptTracking("View Theme Gallery")
      // }

      generalStore.setLoading(false)
      nextTick(()=>fetchDataOnMounted())
      loadingBot.value = !window.IS_BOT

      const dataTripSessionStorage = sessionStorage.getItem('trip_not_found')

      if(dataTripSessionStorage === 'true') {
        modalNotFoundTitle.value = TRIP_NOT_FOUND
        modalNotFoundActive.value = true
        sessionStorage.removeItem('trip_not_found')
      }

      let urlQuery = route.query
      if (
        urlQuery.destination ||
        urlQuery.duration ||
        urlQuery.activity ||
        urlQuery.price ||
        urlQuery.designer ||
        urlQuery.free_cancellation ||
        urlQuery.currency
      )
        clearFilterStatus.value = true
      // await scrollTop()

      setTimeout(async () => {
        await heapTrack(false)
      }, 2000)

      loadingBot.value = true
    })

    // ---Created---
    resetCurrentPage()
      galleryStore.setGalleryInfor(null)
      getTripParams(queryChange.value, {})
      getPopularDestParams({})
      loading.value = true
      clearTravelGuideData()

      if (route.name === 'trip-gallery') {
          filterParams.exclude_level = 2
          await getDataTrips(tripParams)

          // DJ-12207
          loading.value = false
          loaded.value = true
          // await Promise.all([getDataTrips(tripParams), getFilterOptions(filterParams), getPopularDestination(popularDestParams)])
      }

      if (
        route.name === 'types-gallery' ||
        route.name === 'free-cancellation-trips'
      ) {
          const resData = await getDataGalleryPage()
          if (!isEmpty(resData)) {
            const arrRequest = []
            galleryPageData.value = resData
            const paramSetting = resData?.filter_options

            if (queryChange.value || paramSetting) {
              mapFilterParams(paramSetting, resData.settings.page_type)
              getTripParams(queryChange.value, paramSetting)
              getPopularDestParams(paramSetting)
              arrRequest.push(getDataTrips(tripParams))
              // await Promise.all([getDataTrips(tripParams), getFilterOptions(filterParams), getPopularDestination(popularDestParams), await getQuickLinksData(resData)])
              if (resData.settings.page_type === 'country' || resData.settings.page_type === 'destination') {
                const params = {
                  country_url: route.params.types_,
                  country_code: paramSetting.country_codes,
                  region_id: paramSetting.region_id,
                  theme_id:
                    paramSetting.theme_id > 0 ? paramSetting.theme_id : undefined,
                  introduction: 1,
                }

                // isCountryGallery.value = true
                arrRequest.push(getTravelGuide(params))
              }
              await Promise.all(arrRequest)
              loading.value = false
              loaded.value = true
            }

            if (totalData.value === 0) {
              if (tripParams.page > cardDataList.value.last_page && !cardDataList.value.has_ld_coverage) {
                navigateTo({name: 'trip-gallery'})
              }
            }
          } else {
            galleryStore.setGalleryInfor(resData)
            navigateTo({name: 'trip-gallery'})
          }
      }
</script>

<style scoped lang="scss">
// v2 — full-viewport loading overlay (pinned via .fixed inset-0 in the template).
// Backdrop uses the $scrim seam: cream first-paint veil in light (guide §15; was hardcoded
// white rgba(255,255,255,0.85)) → dark-canvas veil in dark (--dj-scrim). The spinner is
// position:fixed below, so it stays viewport-centred regardless of the overlay box.
.loading-mask {
  background: $scrim;

  // green three-dot spinner (matches ui/loading/Loading + AppLoading)
  .loader {
    position: fixed; // center in the viewport, not the (often very tall) results container
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 38px;
    aspect-ratio: 2;
    --_g: no-repeat radial-gradient(circle closest-side, #{$brand-green} 90%, transparent);
    background: var(--_g) 0% 50%, var(--_g) 50% 50%, var(--_g) 100% 50%;
    background-size: calc(100% / 3) 50%;
    animation: loading 1s infinite linear;
  }
  // §11 — respect reduced-motion (static dots instead of the cycling animation)
  @media (prefers-reduced-motion: reduce) {
    .loader { animation: none; }
  }
}

@keyframes loading {
  20% { background-position: 0% 0%, 50% 50%, 100% 50%; }
  40% { background-position: 0% 100%, 50% 0%, 100% 50%; }
  60% { background-position: 0% 50%, 50% 100%, 100% 0%; }
  80% { background-position: 0% 50%, 50% 50%, 100% 100%; }
}
// v2 inline text link — green, weight 500, underline on hover only, green focus ring
// (was <span class="black underline"> — black with a resting underline; the base anchor is off-brand blue)
.submit-enquiry-link {
  color: $link;
  font-weight: 500;
  text-decoration: none;
  @include focus-ring;
  &:hover,
  &:focus-visible {
    color: $link;
    text-decoration: underline;
  }
}
#page-gallery {
  background-color: $background; // Wave 5A cream canvas (--dj-bg seam, W7-ready); cream-deep banner sits on top

  @include desktop {
    position: relative;
    width: 100vw;
    overflow: hidden;
  }
}
.filter {
  width: 266px;
  min-width: 266px;
}
.trip-list {
  width: calc(100% - 266px);
  padding-left: 63px;

  &-card {
    grid-template-columns: repeat(auto-fit, minmax(280px,1fr));
    gap: 20px;
  }

  @include tablet {
    width: 100%;
    padding-left: 0px;
  }
}
.trip-card {
  display: flex;

  &:only-child {
    max-width: 280px;
  }
}
@include phone {
  .filter,
  .trip-list {
    width: 100%;
    min-width: 100%;
    padding: 0;
  }
}
</style>
